export enum ActionTypes {
    CONFIG_LOADED = 'OW_CONFIG_LOADED',
    UI_INTEGRATE_UPDATED = 'OW_UI_INTEGRATE_UPDATED',
    UI_BYOD_UPDATED = 'OW_UI_BYOD_UPDATED',
    UI_WEBHOOK_UPDATED = 'OW_UI_WEBHOOK_UPDATED',
}



// WEBPACK FOOTER //
// ./src/sub-projects/openweathermap/types/action-types.ts